import { HttpProvider } from "../http/http.provider";
import { ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHttpRequestConfig } from "../http/types/http.types";
import { IAnouncement, INewAnouncement, IUpdateAnouncementResponse } from "./anouncement.interface";

export class AnouncementDelegate
{
    constructor(private http: HttpProvider)
    {
    }

    public getAllAnouncements(orgId: string): Observable<IAnouncement[]>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.ANOUNCEMENT.GET_ALL_ANOUNCEMENT, null, config).pipe(
            map((response: any) =>
            {
                return this.normalizeAnouncements(response.data.anouncements);
            }),
            share());
    }

    public createNewAnouncement(newAnouncement: INewAnouncement): Observable<IUpdateAnouncementResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.ANOUNCEMENT.CREATE_ANOUNCEMENT, newAnouncement).pipe(
            map((response: any) =>
            {
                return {
                    anouncements: this.normalizeAnouncements(response.data.anouncements),
                    id: response.data.anouncementId
                };
            }),
            share());
    }

    public updateAnouncement(anouncement: IAnouncement): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.ANOUNCEMENT.UPDATE_ANOUNCEMENT, anouncement).pipe(
            map((response: any) =>
            {
                return this.normalizeAnouncements(response.data.anouncements);
            }),
            share());
    }

    private normalizeAnouncements(anouncements: any): IAnouncement[]
    {
        return anouncements.map(anouncement =>
        {
            anouncement.fromDate = new Date(anouncement.fromDate).toLocaleDateString();
            anouncement.toDate = new Date(anouncement.toDate).toLocaleDateString();
            return anouncement;
        });
    }
}